import Http from '../libs/http';

export default {

  // 历史发票查询
  invoiceBriefQuery(params) {
    return Http.post('/invoice_brief_query', params);
  },

  // 可以开发票的订单查询
  invoiceOrderBriefQuery(params) {
    return Http.post('/invoice_order_brief_query', params);
  },

  // 提交发票
  invoiceSubmit(params) {
    return Http.post('/invoice_submit', params, { noToast: true });
  },

  // 支付发票
  invoicePay(params) {
    return Http.post('/invoice_pay', params);
  },

  // 发票修改
  invoiceUpdate(params) {
    return Http.post('/invoice_update', params);
  },

  // 发票查询
  invoiceQuery(params) {
    return Http.post('/invoice_query', params);
  },

  // 查询支付
  invoicePayQuery(params) {
    return Http.post('/invoice_pay_query', params);
  },

  // 历史发票价格检测
  invoiceCheck(params) {
    return Http.post('/invoice_check', params);
  },

  // 取消发票
  invoiceCancel(params) {
    return Http.post('/invoice_cancel', params);
  },
}
;



// WEBPACK FOOTER //
// ./src/api/invoice-api.js